module.exports = __webpack_public_path__ + "static/media/OutliersQ7_3.8df65cff.svg";